module.exports = __webpack_public_path__ + "static/media/out-of-work-benefits.d37d1a62.svg";